import { IState } from '../../store';
import { ITransportAccessibility } from '../../types/transportAccessibility';

export const selectTransportAccessibility = (state: IState): ITransportAccessibility | null => {
  const { transportAccessibility } = state.offerData;

  if (!transportAccessibility) {
    return null;
  }

  return transportAccessibility.transport || null;
};
